const PADDING = 'pad';
const MARGIN = 'margin';
const SPACE_AMOUNT = 'eighth|quarter|half|one-and-half|one|two|three|four';
const SPACE_PLACE = 'vert|top|btm|horiz|right|left';

const allSpacingReg = new RegExp(`^(uni-(?:${PADDING}|${MARGIN})--(?:${SPACE_AMOUNT}))((--)(\\w+))?$`);
const marginReg = new RegExp(`^(uni-${MARGIN}--(?:${SPACE_AMOUNT}))((--)(\\w+))?$`);
const paddingReg = new RegExp(`^(uni-${PADDING}--(?:${SPACE_AMOUNT}))((--)(\\w+))?$`);
const spacePlaceReg = new RegExp(SPACE_PLACE);

const testClassName = reg => className => {
  const match = className.match(reg);

  if (!match) return false;

  // There was not a place modifier at the end of the string
  if (match[2] === undefined) return true;

  // If there was a place modifier in the class name,
  // make sure its a valid place modifier
  return spacePlaceReg.test(match[4]);
};

/* eslint-disable consistent-return */
const generateSpacingClassNamePropType = (reg, messageLink) => (props, propName, componentName) => {
  const classNamesString = props[propName];
  const classNameTester = testClassName(reg);

  if (!classNamesString) return;

  const classNamesStringType = typeof classNamesString;

  if (classNamesStringType !== 'string') {
    /* eslint-disable max-len */
    return new Error(
      `Invalid prop \`${propName}\` of type \`${classNamesStringType}\` supplied to \`${componentName}\`, expected \`string\`.`
    );
    /* eslint-enable max-len */
  }

  const classNames = classNamesString.split(' ');

  const allClassNamesAreValid = classNames.every(classNameTester);

  if (allClassNamesAreValid) return;

  const failingClassNames = classNames.filter(className => !classNameTester(className));

  /* eslint-disable max-len */
  return new Error(
    `Invalid prop \`${propName}\` contains classes (${failingClassNames.join(
      ', '
    )}) that are not uniCSS spacing classes. See the list of classes here ${messageLink}`
  );
  /* eslint-enable max-len */
};
/* eslint-enable consistent-return */

export const marginClassNamePropType = generateSpacingClassNamePropType(
  marginReg,
  'http://hudl.github.io/uniform-ui-docs/web/css/space/#margin'
);

export const paddingClassNamePropType = generateSpacingClassNamePropType(
  paddingReg,
  'http://hudl.github.io/uniform-ui-docs/web/css/space/#padding'
);

export const spacingClassNamePropType = generateSpacingClassNamePropType(
  allSpacingReg,
  'http://hudl.github.io/uniform-ui-docs/web/css/space'
);



// WEBPACK FOOTER //
// ./src/__utils/spacingClassNamePropType.js